import React from 'react';
import {
  ButtonGroup,
  LabelTitle,
  ModalDescription,
  SelectExportCentersContainer,
} from './styles/SelectExportCenters';
import {
  SVGImagesSet,
} from './styles/Images';
import { Button } from 'lego-dist';

interface SuccessfulExportCentersProps {
  t: (section: string) => string;
  email: string;
  onCloseModal: (val: boolean) => void;
}

const SuccessfulExportCentersView: React.FC<SuccessfulExportCentersProps> = ({
  t, email, onCloseModal,
}) => {
  const Title = <LabelTitle center>{t('settings:EXPORT_DATA.MODAL_SUCCESS.TITLE')}</LabelTitle>;
  const initialDescription = t('settings:EXPORT_DATA.MODAL_SUCCESS.DESCRIPTION_PART_ONE');
  const finalDescription = t('settings:EXPORT_DATA.MODAL_SUCCESS.DESCRIPTION_PART_TWO');
  const UserEmail = () => (<b>{email}</b>);

  const ModalText = (
    <SelectExportCentersContainer>
      <SVGImagesSet />
      {Title}
      <ModalDescription>
        {initialDescription}
        <UserEmail />
        {finalDescription}
      </ModalDescription>
      <ButtonGroup center>
        <Button
          flat
          rounded
          onClick={() => onCloseModal(false)}
          color="var(--cognitive-green)"
        >
          {t('settings:EXPORT_DATA.MODAL_SUCCESS.BUTTON')}
        </Button>
      </ButtonGroup>
    </SelectExportCentersContainer>
  );
  return ModalText;
};

export default SuccessfulExportCentersView;
